"use strict";

export function initInScope($scope) {
    const $toast = $scope.find('.js-toast');
    const toastId = $toast.data('toast-id');
    const localStorageKey = `toast-${toastId}`;

    if (!localStorage.getItem(localStorageKey)) {
        setTimeout(() => {
            $toast.toast('show');
        }, 850);
    }
    $toast.on('hidden.bs.toast', () => {
        localStorage.setItem(localStorageKey, 'closed');
    });
}

